import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Role.List.IRequest;
type Response = Api.Core.Role.List.IResponse;
type Headers = Api.Core.Role.List.IHeaders;
const url = '/api/Management/Role';
export default async function roleListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
